<template>
    <p>
        {{ date }}
    </p>
</template>

<script>
import {dates} from '../../../../../core/filters'
export default {
    name: 'Date',
    filters: {
        formatDate: dates.formatDate,
        secondsToDateMonth: dates.secondsToDateMonth
    },
    props: {
        data: [String, Object]
    },
    computed: {
        date(){
            return  this.data && this.data._seconds ? 
                    this.$options.filters.secondsToDateMonth(this.data._seconds) :
                    this.$options.filters.formatDate(this.data)
        }
    }
}
</script>

<style>

</style>